
window.addEventListener("load", function () {
    $('.MJ__click').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

     

        $('#lan-header').addClass('active');
    });

 
    $('body').on('click', function () {
  
        if ($('#lan-header').hasClass('active')) {
            $('#lan-header').removeClass('active');
        }
    });
});